import { useAuth } from '@clerk/clerk-react'
import { useCallback } from 'react'

type AuthTokenData = {
  readonly isLoaded: boolean
  readonly isSignedIn: boolean
  readonly getToken: () => Promise<string | null>
}

export function useAuthToken(): AuthTokenData {
  const { getToken, isLoaded, isSignedIn } = useAuth()

  const getAuthToken = useCallback(async (): Promise<string | null> => {
    if (!isSignedIn) {
      return null
    }

    try {
      return await getToken()
    } catch (error) {
      console.error('Failed to get auth token:', error)
      return null
    }
  }, [getToken, isSignedIn])

  return {
    getToken: getAuthToken,
    isLoaded,
    isSignedIn: isSignedIn ?? false,
  }
}
